<script>
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import CallReport115Helper from '@/Helpers/Report/115/CallReport115Helper.js';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import RecentCallMixin from '@/Mixins/800/Report/RecentCall.mixin';
import RecentCallHelper from '@/Helpers/800/Report/RecentCall.helper';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPagination from '@/components/app/Pagination.vue';
import AppDatePicker from '@/components/app/DatePicker.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
export default {
  name: 'CallReport115',
  title: 'گزارش تماس های اخیر 800',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    AppPagination,
    AppDatePicker,
    AppPageContainer,
  },
  mixins: [
    ShearedMixin,
    MissionMixin,
    CallReport115Helper,
    snackBar,
    ShearedHelper,
    CallMixin,
    RecentCallMixin,
    RecentCallHelper,
    UserNotificationMixin,
  ],
  created() {
    this.$root.$refs.Recent800Calls = this;
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getRecentCallsListHandler();
      this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
      this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
    isNotMissingCall: function (call) {
      return call?.result !== 'تماس از دست رفته';
    },
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    delete this.$root.$refs.Recent800Calls;
  },
};
</script>
<template>
  <app-page-container title="تماس های اخیر 800">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="2" class="">
        <v-btn fab small dark @click="showFilterModal" class="darkColor mt-3 mr-n3">
          <v-icon>mdi-filter mdi-18</v-icon>
        </v-btn>
        <v-tooltip v-if="haveFilters" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="clearFilter()" class="mt-3 mr-4">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters>
        <v-col cols="12" class="pa-0">
          <template>
            <v-data-table fixed-header id="recent-call-table" :headers="recentCallTableHeaders" :items="recentCallsList"
              :search="searchTitle" :items-per-page="recentCallsList.length" height="70vh" :hide-default-footer="true"
              multi-sort class="elevation-0">
              <template v-slot:[`item.actions`]="{ item }">
                <v-row v-if="isNotMissingCall(item)">
                  <v-spacer></v-spacer>
                  <v-tooltip>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs"
                        @click="playAudioHandler(item.callLogId)" v-on="on">
                        mdi-play mdi-32px
                      </v-icon>
                    </template>
                    <span>پخش صوت</span>
                  </v-tooltip>
                  <v-tooltip v-if="haveDownloadAudioPermmistion" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" @click="
                        downloadAudioFileHandler(item.callLogId, item?.fromTheNumber)
                        " v-bind="attrs" v-on="on">
                        mdi-tray-arrow-down mdi-32px
                      </v-icon>
                    </template>
                    <span>دانلود صوت</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                </v-row>
              </template>
              <template v-slot:no-data>
                <span>اطلاعاتی جهت نمایش وجود ندارد</span>
              </template>
            </v-data-table>
          </template>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-row no-gutters>
            <v-col cols="11">
              <v-spacer></v-spacer>
              <app-pagination :totalPages="totalPages" v-model="pagination" />
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <!--audio ***********************************************-->
        <!-- <v-dialog v-model="player" width="400px" style="overflow-x: hidden" :key="recordFile">
          <v-card width="400px">
            <v-row justify="center" style="overflow-x: hidden" no-gutters>
              <v-col cols="10" style="text-align: center" class="mt-4">
                <audio controls oncontextmenu="return false;" controlsList="nodownload" cors-anonym="true" autoplay
                  :src="recordFile" ref="audioFile"></audio>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="no-letter-space" @click="stopMusic()">بستن B</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <v-dialog width="354" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-2">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-filter</v-icon>
                  <span class="modal-title-text mr-2">فیلتر</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.Source" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="از"
                    class="input-label" prepend-inner-icon="mdi-phone mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.Destination" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="به"
                    class="input-label" prepend-inner-icon="mdi-phone mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchMissionIdentifier" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="نتیجه"
                    class="input-label" prepend-inner-icon="mdi-file-document mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.UserId" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="کاربر"
                    class="input-label" prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <app-date-picker v-model="searchFields.fromDate" label="از تاریخ" inputID="fromDate" />
                </v-col>
                <v-col cols="12">
                  <app-date-picker label="تا تاریخ" inputID="toDate" v-model="searchFields.toDate" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="searchFieldsHandler()" dark rounded tabindex="6"
                class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined tabindex="7" @click="closeSearchModal()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<style lang="scss">
#recent-call-table {
  thead {
    tr {
      background: white !important;
      position: sticky !important;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
}
</style>
<style lang="scss" scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}



>>>table tbody tr td:nth-child(11),
>>>table thead tr th:nth-child(11) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0 !important;
  z-index: 9998 !important;
  background: white !important;
}

table>thead>tr>th:nth-child(11) {
  z-index: 9999 !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
